import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { fetchOrderById } from "../../../../../../reduxLib/ordersLib";
import {fetchDeliveryById, updateDeliverySubInfo} from "../../../../../../reduxLib/deliveryLib";
import {updateAddress} from "../../../../../../reduxLib/adressLib";
// import { updateDelivery } from "../../../../../../reduxLib/deliveryLib";

function ViewAndModifyDeliveryModal({ isOpen, onClose, delivery,invoiceId, }) {

    const dispatch = useDispatch();

    const [orderDetails, setOrderDetails] = useState(null);
    const [deliveryStatus, setDeliveryStatus] = useState("");
    const [deliveryEstimationArival, setDeliveryEstimationArival] = useState("");
    const [comments, setComments] = useState("");
    const [lastUpdate, setLastUpdate] = useState(null);

    const [isAddressEditable, setIsAddressEditable] = useState(false);
    const [address, setAddress] = useState({
        street: "",
        region: "",
        city: "",
        postalCode: "",
        country: "",
    });
    const [isSavingAddress, setIsSavingAddress] = useState(false);

    useEffect(() => {
        if (!isOpen || !delivery?.orderRelId) return;
        setIsAddressEditable(false);


        dispatch(fetchOrderById(delivery.orderRelId)).then((action) => {
            if (!action.payload) return;

            setOrderDetails(action.payload);
           // console.log("statoules    "+action.payload.delivery?.deliveryID);

            setDeliveryStatus(
                action.payload.delivery?.deliveryStatus || ""
            );


            setAddress({
                street: action.payload.delivery?.address?.street || "",
                region: action.payload.delivery?.address?.region || "",
                city: action.payload.delivery?.address?.city || "",
                postalCode: action.payload.delivery?.address?.postalCode || "",
                country: action.payload.delivery?.address?.country || "",
            });



            const deliveryID = action.payload.delivery?.deliveryID;

            if (!deliveryID) return;

            dispatch(fetchDeliveryById(deliveryID)).then((deliveryAction) => {
                if (!deliveryAction.payload) return;

                const fetchedDelivery = deliveryAction.payload;

                setDeliveryStatus(fetchedDelivery.deliveryStatus || "");

                setDeliveryEstimationArival(
                    fetchedDelivery.deliveryEstimationArival
                        ? fetchedDelivery.deliveryEstimationArival.slice(0, 16)
                        : ""
                );

                setComments(fetchedDelivery.comments || "");
                setLastUpdate(fetchedDelivery.lastUpdate || null);
            });
        });
    }, [isOpen, delivery?.orderRelId, dispatch]);

    if (!isOpen || !delivery) return null;
    const handleSaveAddress = async () => {
        const payload = {
            addressID: orderDetails?.delivery?.address?.addressID,
            ...address,
        };

        console.log("update address payload", payload);

        setIsSavingAddress(true);

        try {
            const updatedAddress = await dispatch(updateAddress(payload)).unwrap();
            const nextAddress = updatedAddress || payload;

            setAddress({
                street: nextAddress.street || "",
                region: nextAddress.region || "",
                city: nextAddress.city || "",
                postalCode: nextAddress.postalCode || "",
                country: nextAddress.country || "",
            });


            setOrderDetails((prev) => ({
                ...prev,
                delivery: {
                    ...prev.delivery,
                    address: {
                        ...prev.delivery.address,
                        ...nextAddress,
                    },
                },
            }));

            setIsAddressEditable(false);
        } finally {
            setIsSavingAddress(false);
        }
    };



    const handleSave = () => {
        const payload = {
            deliveryID: orderDetails?.delivery?.deliveryID,
            deliveryStatus,
            deliveryEstimationArival: deliveryEstimationArival || null,
            comments,
        };

        console.log("update delivery payload", payload);

        dispatch(updateDeliverySubInfo(payload)).then(() => {
            onClose();
         });
    };

    return (
        <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4">
            <div className="bg-white rounded-lg shadow-lg w-full max-w-5xl relative max-h-[90vh] overflow-y-auto">
                <div className="border-b px-6 py-4 flex justify-between items-center">
                    <h2 className="text-xl font-serif font-bold text-custom-green">
                        View & Modify Delivery
                    </h2>

                    <button onClick={onClose} className="text-gray-500 hover:text-black">
                        <i className="fa-solid fa-xmark text-xl"></i>
                    </button>
                </div>

                <div className="p-6 space-y-6">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div>
                            <label className="text-sm font-medium text-gray-700">
                                Delivery ID
                            </label>

                            <input
                                value={orderDetails?.delivery?.deliveryID || ""}
                                disabled
                                className="w-full border rounded-lg p-2 mt-1 bg-gray-100"
                            />
                        </div>

                        <div>
                            <label className="text-sm font-medium text-gray-700">
                                Delivery Information
                            </label>

                            <div className="space-y-2 mt-1">
                                <input
                                    value={
                                        orderDetails?.delivery?.delivery_Number || ""
                                    }
                                    disabled
                                    className="w-full border rounded-lg p-2 bg-gray-100"
                                />

                                {orderDetails?.delivery?.tracking_Number ? (
                                    <input
                                        value={
                                            orderDetails.delivery.tracking_Number
                                        }
                                        disabled
                                        className="w-full border rounded-lg p-2 bg-gray-100"
                                    />
                                ) : (
                                    <p className="text-orange-500 text-sm font-medium">
                                        Η παραγγελία δεν έχει ακόμα αποσταλεί.
                                    </p>
                                )}
                            </div>
                        </div>
                    </div>

                    <div>
                        <h3 className="font-bold text-custom-green mb-3">
                            Products
                        </h3>

                        <div className="border rounded-lg divide-y">
                            {orderDetails?.products?.map((product) => (
                                <div
                                    key={product.productID}
                                    className="flex items-center gap-4 p-3"
                                >
                                    <img
                                        src={product.imageURL}
                                        alt={product.name}
                                        className="w-14 h-14 object-cover rounded"
                                    />

                                    <div className="flex-1">
                                        <p className="font-medium text-gray-900">
                                            {product.name}
                                        </p>
                                    </div>

                                    <p className="font-semibold text-gray-800">
                                        €{Number(product.price ?? 0).toFixed(2)}
                                    </p>
                                </div>
                            ))}
                        </div>

                        {/* Total Cost */}
                        <div className="border-t bg-gray-50 px-4 py-3 flex justify-end">
                            <div className="text-right">
                                <p className="text-sm text-gray-500">
                                    Total Cost
                                </p>

                                <p className="text-xl font-bold text-custom-green">
                                    €
                                    {Number(
                                        orderDetails?.total ?? 0
                                    ).toFixed(2)}
                                </p>
                            </div>
                        </div>
                        {Number(delivery.totalPrice ?? 0) > 100 && (
                            <div className="text-xs text-orange-600 mt-1 font-medium">
                                Ο πελάτης δεν χρεώνεται με μεταφορικά
                            </div>
                        )}
                    </div>

                    <div>
                        <h3 className="font-bold text-custom-green mb-3">
                            Address
                        </h3>

                        <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
                            {["street", "region", "city", "postalCode", "country"].map((field) => (
                                <div key={field}>
                                    <label className="text-sm font-medium text-gray-700">
                                        {field}
                                    </label>

                                    <input
                                        value={address[field]}
                                        disabled={!isAddressEditable}
                                        onChange={(e) =>
                                            setAddress((prev) => ({
                                                ...prev,
                                                [field]: e.target.value,
                                            }))
                                        }
                                        className={`w-full border rounded-lg p-2 mt-1 ${
                                            isAddressEditable
                                                ? "bg-white"
                                                : "bg-gray-100"
                                        }`}
                                    />
                                </div>
                            ))}
                        </div>
                        <div className="mt-8"/>
                        <div className="flex justify-between items-center mb-4">
                            <button
                                type="button"
                                onClick={() => setIsAddressEditable(true)}
                                className="border border-custom-green text-custom-green px-4 py-2 rounded-lg hover:bg-custom-green hover:text-white"
                            >
                                διόρθωση διεύθυνσης
                            </button>
                            <button
                                type="button"
                                onClick={handleSaveAddress}
                                disabled={!isAddressEditable || isSavingAddress}
                                className="bg-custom-green text-white px-4 py-2 rounded-lg disabled:opacity-50 disabled:cursor-not-allowed"
                            >
                                {isSavingAddress ? "Αποθήκευση..." : "αποθήκευση νέας διεύθυνσης"}
                            </button>
                        </div>
                    </div>

                    <div>
                        <h3 className="font-bold text-custom-green mb-3">
                            Modify Delivery
                        </h3>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div>
                                <label className="text-sm font-medium text-gray-700">
                                    Delivery Status
                                </label>
                                <select
                                    value={deliveryStatus}
                                    onChange={(e) => setDeliveryStatus(e.target.value)}
                                    className="w-full border rounded-lg p-2 mt-1"
                                >
                                    <option value="pending">Pending</option>
                                    <option value="in_transit">In Transit</option>
                                    <option value="completed">Delivered</option>
                                    <option value="cancelled">Cancelled</option>
                                </select>
                            </div>

                            <div>
                                <label className="text-sm font-medium text-gray-700">
                                    Estimated Arrival
                                </label>
                                <input
                                    type="datetime-local"
                                    value={deliveryEstimationArival}
                                    onChange={(e) =>
                                        setDeliveryEstimationArival(e.target.value)
                                    }
                                    className="w-full border rounded-lg p-2 mt-1"
                                />
                            </div>

                            <div className="md:col-span-2">
                                <label className="text-sm font-medium text-gray-700">
                                    Comments
                                </label>
                                <textarea
                                    value={comments}
                                    onChange={(e) => setComments(e.target.value)}
                                    className="w-full border rounded-lg p-3 mt-1 min-h-[120px]"
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="border-t px-6 py-4 flex justify-end gap-3">
                    <div className="flex justify-between items-center mb-3">
                        <p className="text-xs text-gray-500">
                            {lastUpdate
                                ? `Last update: ${new Date(lastUpdate).toLocaleString("el-GR", {
                                    day: "2-digit",
                                    month: "2-digit",
                                    year: "numeric",
                                    hour: "2-digit",
                                    minute: "2-digit",
                                })}`
                                : "Last update: -"}
                        </p>
                    </div>
                    <button onClick={onClose} className="border px-4 py-2 rounded-lg">
                        Cancel
                    </button>

                    <button
                        onClick={handleSave}
                        className="bg-custom-green text-white px-4 py-2 rounded-lg"
                    >
                        Save Changes
                    </button>
                </div>
            </div>
        </div>
    );
}

export default ViewAndModifyDeliveryModal;